export interface TemplateProps {}

export enum TemplateType {
    Email = 'Email',
    SMS = 'SMS'
}